// ACCOUNT HOMEPAGE (aka. bookings overview) -----

// Import shared
require('./shared')

// Import widgets
require('../../widgets/customer-discounts/main')
require('../../widgets/welcome-user/main')
require('../../widgets/action-modal/main')
require('../../widgets/delete-account/main')

require('../../../js/core/widget/widget-api')

// Autoload all components when the page is ready
const { autoload } = require('../../../js/document/load-queue')
autoload()
